import { ReactNode } from 'react';

const text: ReactNode = (
  <>
    <p id="consent-text-first-paragraph" data-testid="consent-text-paragraphs">
      Declaro que ASSA COMPAÑÍA DE SEGUROS COSTA RICA S.A. cédula jurídica
      3-101-593961 (en adelante &quot;ASSA&quot;) será la destinataria y
      almacenará toda la información que le brinde, y/o que ASSA recopile de
      terceras fuentes previamente autorizadas, esta información será almacenada
      en la Base de Datos de la cual ASSA es la responsable.
    </p>
    <p id="consent-text-second-paragraph">
      Para ofrecer sus servicios, ASSA podrá utilizar información de carácter
      personal tal como, pero sin limitarse a, datos personales, información de
      contacto, información del vehículo a asegurar, información laboral, datos
      laborales y de origen de los fondos, información financiera e información
      de beneficiarios.
    </p>
    <p id="consent-text-third-paragraph">
      Dicha información podrá ser consultada por colaboradores, intermediarios,
      proveedores, empresas reaseguradoras, ajustadores externos nacionales o
      internacionales.
    </p>
    <p id="consent-text-fourth-paragraph">
      Entiendo y consiento en que por medio del sistema CREDID de ALUDEL
      LIMITADA cédula Jurídica 3-102-189003 pueda ASSA consultarme a la base de
      Datos GLOBAL ID - GENERAL de la cual es responsable las empresas GLOBAL ID
      ON LINE COSTA RICA S.A., cédula de persona jurídica número 3-101-552730.
    </p>
    <p id="consent-text-fifth-paragraph">
      En todo momento podré por medio del correo servicio@assanet.com, ejercer
      los derechos de acceso de los datos personales, rectificación o supresión.
      Entiendo que el fin que ASSA persigue es analizar el otorgamiento de una
      póliza y cumplir con requisitos regulatorios para dicho fin.
    </p>
    <p id="consent-text-sixth-paragraph">
      Asimismo, acepto que todos los datos que se brindarán son de forma
      facultativa; sin embargo, en caso de negarme a brindar alguna información
      o dar el consentimiento para ser verificado en terceras bases de datos de
      conformidad con lo indicado anteriormente, ASSA podrá estar imposibilitada
      para brindar algunos de sus servicios.
    </p>
    <p id="consent-text-seventh-paragraph">
      En términos generales por la firma del presente estoy autorizando a ASSA,
      ALUDEL y GLOBAL ID en lo conducente de manera expresa e informada.
    </p>
  </>
);

function ConsentText(): JSX.Element {
  return <>{text}</>;
}

export default ConsentText;
